"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { AccountSessionMixins } from "@/service/account-session";
import { Component, Mixins, PropSync } from "vue-property-decorator";
let BatchOperateRenew = class extends Mixins(AccountSessionMixins) {
  get show() {
    for (let item of this._controller.selected) {
      if (!item.marks.is("IS_ADMIN")) {
        return false;
      }
      if (item.marks.is("DELETE")) {
        return false;
      }
      if (item.marks.is("SHOP_NOT_ALLOW_EDIT_IP")) {
        return false;
      }
    }
    if (this._controller.query.filter.group === "shopgroup_system_recycle") {
      return false;
    }
    return true;
  }
  editShop() {
    this.$emit("editShop");
  }
};
__decorateClass([
  PropSync("controller")
], BatchOperateRenew.prototype, "_controller", 2);
BatchOperateRenew = __decorateClass([
  Component
], BatchOperateRenew);
export {
  BatchOperateRenew as default
};
